import { getTaskRequest, useTask } from '~/contexts/TaskContext'

export function useTaskSubmitUser() {
  const { task: taskObj } = useTask()
  return Number(getTaskRequest(taskObj)?.userId)
}
